import { c as _c } from "react/compiler-runtime";
import { useProgressBar } from 'react-aria';
import { TooltipInfo } from '../tooltip-info/tooltip-info.tsx';
export enum ProgressBarColors {
  inputBackgroundNeutralMild = 'var(--color-input-background-neutral-mild)',
  inputBackgroundModerate = 'var(--color-input-background-moderate)',
}
type ProgressBarProps = {
  label?: string;
  showValueLabel?: boolean;
  value: number;
  minValue?: number;
  maxValue?: number;
  height?: number;
  backgroundBarColor?: ProgressBarColors;
  foregroundBarColor?: ProgressBarColors;
  tooltipMessage?: string;
  usePortal?: boolean;
};
export const ProgressBar: React.FC<ProgressBarProps> = t0 => {
  const $ = _c(35);
  const {
    label,
    showValueLabel: t1,
    value,
    minValue: t2,
    maxValue: t3,
    height: t4,
    backgroundBarColor: t5,
    foregroundBarColor: t6,
    tooltipMessage
  } = t0;
  const showValueLabel = t1 === undefined ? false : t1;
  const minValue = t2 === undefined ? 0 : t2;
  const maxValue = t3 === undefined ? 100 : t3;
  const height = t4 === undefined ? 8 : t4;
  const backgroundBarColor = t5 === undefined ? ProgressBarColors.inputBackgroundNeutralMild : t5;
  const foregroundBarColor = t6 === undefined ? ProgressBarColors.inputBackgroundModerate : t6;
  let t7;
  if ($[0] !== label || $[1] !== maxValue || $[2] !== minValue || $[3] !== value) {
    t7 = {
      label,
      value,
      minValue,
      maxValue
    };
    $[0] = label;
    $[1] = maxValue;
    $[2] = minValue;
    $[3] = value;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  const {
    progressBarProps,
    labelProps
  } = useProgressBar(t7);
  const progressValue = Math.min(Math.max(value, minValue), maxValue);
  const denominator = maxValue === minValue ? 1 : maxValue - minValue;
  const percentage = (progressValue - minValue) / denominator;
  let t8;
  if ($[5] !== percentage) {
    t8 = Math.round(percentage * 100);
    $[5] = percentage;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  const barWidth = `${t8}%`;
  let t9;
  if ($[7] !== label || $[8] !== labelProps) {
    t9 = label && <span style={{
      fontSize: "var(--font-label-amplified-md-font-size)"
    }} {...labelProps}>{label}</span>;
    $[7] = label;
    $[8] = labelProps;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== progressBarProps || $[11] !== showValueLabel) {
    t10 = showValueLabel && <span>{progressBarProps["aria-valuetext"]}</span>;
    $[10] = progressBarProps;
    $[11] = showValueLabel;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t10 || $[14] !== t9) {
    t11 = <div className="flex justify-between">{t9}{t10}</div>;
    $[13] = t10;
    $[14] = t9;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== backgroundBarColor || $[17] !== height) {
    t12 = {
      height,
      background: backgroundBarColor
    };
    $[16] = backgroundBarColor;
    $[17] = height;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== barWidth || $[20] !== foregroundBarColor || $[21] !== height) {
    t13 = <div className="rounded-lg" style={{
      width: barWidth,
      height,
      background: foregroundBarColor
    }} />;
    $[19] = barWidth;
    $[20] = foregroundBarColor;
    $[21] = height;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t12 || $[24] !== t13) {
    t14 = <div className="rounded-lg w-full" style={t12}>{t13}</div>;
    $[23] = t12;
    $[24] = t13;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== tooltipMessage) {
    t15 = tooltipMessage && <TooltipInfo contentClassName="label-md lg:label-lg" align="end" size="sm" alignOffset={-12} sideOffset={2} collisionPadding={16}>{tooltipMessage}</TooltipInfo>;
    $[26] = tooltipMessage;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== t14 || $[29] !== t15) {
    t16 = <div className="flex items-center gap-snug-lg">{t14}{t15}</div>;
    $[28] = t14;
    $[29] = t15;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== progressBarProps || $[32] !== t11 || $[33] !== t16) {
    t17 = <div className="flex flex-col gap-snug-md" {...progressBarProps}>{t11}{t16}</div>;
    $[31] = progressBarProps;
    $[32] = t11;
    $[33] = t16;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  return t17;
};